import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { ASSETS, LINKS } from "@/constants/assets";

export const CTASection = () => (
  <section id="contact" className="relative z-[1] text-center py-44 px-6 lg:px-12 overflow-hidden" data-testid="cta-section">
    <div className="logo-watermark-cta">
      <img src={ASSETS.logo} alt="" className="logo-glow-intense-large" />
    </div>
    <div className="absolute inset-0 z-[1] bg-[radial-gradient(ellipse_at_center,rgba(3,11,24,0.7)_0%,rgba(3,11,24,0.5)_40%,rgba(3,11,24,0.3)_70%)]" />

    <div className="relative z-[2]">
      <motion.div
        className="bg-[rgba(3,11,24,0.92)] p-10 rounded-xl max-w-[800px] mx-auto"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <div className="font-orbitron text-sm font-semibold tracking-[5px] uppercase text-[#60A5FA] mb-5 text-shadow text-center">
          Get Started
        </div>
        <h2 className="font-orbitron text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-[4px] mb-5 text-white text-shadow leading-tight">
          Transform Your Practice<br />With Intelligent Workflows
        </h2>
        <p className="font-outfit text-xl lg:text-2xl text-white/90 mb-10 leading-relaxed font-light">
          See how Limitless can layer onto your existing systems and unify care across your organization.
        </p>
        <div className="flex gap-5 justify-center flex-wrap">
          <a
            href={LINKS.jotform}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-base px-10 py-5"
            data-testid="cta-schedule-button"
          >
            BOOK A STRATEGY CALL <ChevronRight className="w-5 h-5" />
          </a>
          <a href={LINKS.gamma} target="_blank" rel="noopener noreferrer" className="btn-secondary text-base px-10 py-5" data-testid="cta-download-button">
            LEARN MORE
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);
